/* ============================================================
   Watch Reserves — product detail behaviour.

   Replaces the React state machine in WatchReservesProductDetail_1.tsx:
   gallery, variant picker, add-to-cart, and the mobile sticky bar.
   Everything the server can render is already rendered — this only
   handles interaction.
   ============================================================ */
(function () {
  'use strict';

  var form = document.querySelector('[data-wr-product-form]');
  if (!form) return;

  /* ── Gallery ─────────────────────────────────────────── */
  (function gallery() {
    var root = document.querySelector('[data-wr-gallery]');
    if (!root) return;

    var slides = root.querySelectorAll('[data-wr-slide]');
    var thumbs = root.querySelectorAll('[data-wr-thumb]');
    var prev = root.querySelector('[data-wr-prev]');
    var next = root.querySelector('[data-wr-next]');
    var counter = root.querySelector('[data-wr-current]');
    var active = 0;

    function show(i) {
      if (i < 0 || i >= slides.length) return;
      slides[active].classList.remove('is-active');
      if (thumbs[active]) thumbs[active].classList.remove('is-active');
      active = i;
      slides[active].classList.add('is-active');
      if (thumbs[active]) {
        thumbs[active].classList.add('is-active');
        thumbs[active].scrollIntoView({ block: 'nearest' });
      }
      if (counter) counter.textContent = String(active + 1);
      if (prev) prev.disabled = active === 0;
      if (next) next.disabled = active === slides.length - 1;
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(Number(t.dataset.wrThumb)); });
    });
    if (prev) prev.addEventListener('click', function () { show(active - 1); });
    if (next) next.addEventListener('click', function () { show(active + 1); });

    // Arrow keys, which the Framer gallery did not support.
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(active - 1);
      if (e.key === 'ArrowRight') show(active + 1);
    });
  })();

  /* ── Mobile carousel dots ────────────────────────────── */
  (function dots() {
    var scroller = document.querySelector('[data-wr-mobile-scroll]');
    var dotWrap = document.querySelector('[data-wr-dots]');
    if (!scroller || !dotWrap) return;
    var dotList = dotWrap.querySelectorAll('[data-wr-dot]');

    dotList.forEach(function (d) {
      d.addEventListener('click', function () {
        var i = Number(d.dataset.wrDot);
        scroller.scrollTo({ left: i * scroller.offsetWidth, behavior: 'smooth' });
      });
    });

    var ticking = false;
    scroller.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(scroller.scrollLeft / scroller.offsetWidth);
        dotList.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        ticking = false;
      });
    }, { passive: true });
  })();

  /* ── Variant picker ──────────────────────────────────── */
  var variants = [];
  try {
    var payload = document.querySelector('[data-wr-variants]');
    if (payload) variants = JSON.parse(payload.textContent);
  } catch (e) { /* single-variant products don't need this */ }

  var idField = form.querySelector('[data-wr-variant-id]');
  var priceEl = document.querySelector('[data-wr-price]');
  var stickyPriceEl = document.querySelector('[data-wr-sticky-price]');
  var buyBtn = form.querySelector('[data-wr-buy]');
  var addBtn = form.querySelector('[data-wr-add]');
  var buyLabel = form.querySelector('[data-wr-buy-label]');
  var addLabel = form.querySelector('[data-wr-add-label]');
  var priceRow = document.querySelector('.wr-pdp-price');

  function currentSelection() {
    var picked = [];
    document.querySelectorAll('[data-wr-option]:checked').forEach(function (input) {
      picked[Number(input.dataset.wrOption) - 1] = input.value;
    });
    return picked;
  }

  function matchVariant(selection) {
    return variants.find(function (variant) {
      return variant.options.every(function (opt, i) { return opt === selection[i]; });
    });
  }

  function setAvailability(available) {
    [buyBtn, addBtn].forEach(function (b) { if (b) b.disabled = !available; });
    if (buyLabel) buyLabel.textContent = available ? 'Buy Now — Checkout' : 'Sold Out';
    if (addLabel) addLabel.textContent = available ? 'Add to Cart' : 'Sold Out';

    var tag = document.querySelector('[data-wr-soldout]');
    if (!available && !tag && priceRow) {
      tag = document.createElement('div');
      tag.className = 'wr-sold-out-tag';
      tag.setAttribute('data-wr-soldout', '');
      tag.textContent = 'Sold Out';
      priceRow.appendChild(tag);
    } else if (available && tag) {
      tag.remove();
    }
  }

  function onOptionChange() {
    var variant = matchVariant(currentSelection());
    if (!variant) { setAvailability(false); return; }
    if (idField) idField.value = variant.id;
    if (priceEl) priceEl.textContent = variant.price;
    if (stickyPriceEl) stickyPriceEl.textContent = variant.price;
    setAvailability(variant.available);

    // Keep the URL shareable, the way a variant link from an ad would arrive.
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  // The option picker sits outside the form so its radios are never posted
  // to /cart/add; it drives the hidden variant id instead.
  document.querySelectorAll('[data-wr-option]').forEach(function (input) {
    input.addEventListener('change', onOptionChange);
  });

  /* ── Cart ────────────────────────────────────────────── */
  var returnTo = form.querySelector('[data-wr-return-to]');
  var busy = false;

  function updateCartBadge(count) {
    var link = document.querySelector('[data-wr-cart-link]');
    if (!link) return;
    var badge = link.querySelector('[data-wr-cart-count]');
    if (count > 0 && !badge) {
      badge = document.createElement('span');
      badge.className = 'wr-cart-badge';
      badge.setAttribute('data-wr-cart-count', '');
      link.appendChild(badge);
    }
    if (badge) badge.textContent = count > 9 ? '9+' : String(count);
  }

  function flash(labelEl, text, revert) {
    if (!labelEl) return;
    labelEl.textContent = text;
    setTimeout(function () { labelEl.textContent = revert; }, 1800);
  }

  var CART_DRAWER_SECTION_ID = 'wr-cart-drawer-section';

  function swapCartDrawerSection(sections) {
    var html = sections && sections[CART_DRAWER_SECTION_ID];
    var host = document.getElementById('shopify-section-' + CART_DRAWER_SECTION_ID);
    if (!html || !host) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.getElementById('shopify-section-' + CART_DRAWER_SECTION_ID);
    host.innerHTML = fresh ? fresh.innerHTML : parsed.body.innerHTML;
  }

  function openCartDrawer() {
    var dialog = document.getElementById('cart-drawer');
    if (dialog && !dialog.open) dialog.showModal();
  }

  function addToCart() {
    if (busy || !idField) return;
    busy = true;
    if (addLabel) addLabel.textContent = 'Adding...';

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idField.value), quantity: 1 }], sections: CART_DRAWER_SECTION_ID })
    })
      .then(function (r) {
        // A 429 carrying HTML is a Cloudflare bot challenge, not Shopify
        // throttling — common for shoppers on VPNs, whose shared exit IPs
        // carry poor reputation. A background fetch can't render or solve
        // a challenge, so it dies here with no way forward. A top-level
        // navigation CAN: reloading lets the browser show the challenge,
        // earn its cf_clearance cookie, and every later request (this add
        // included) then passes. Without this the button is simply dead.
        if (r.status === 429) {
          var type = r.headers.get('content-type') || '';
          if (type.indexOf('text/html') !== -1) throw new Error('challenge');
          throw new Error('rate-limited');
        }
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (addResponse) {
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          updateCartBadge(cart.item_count);
          flash(addLabel, 'Added ✓', 'Add to Cart');
          swapCartDrawerSection(addResponse.sections);
          // Show the confirmation for the piece just added; fall back to
          // the full cart if the response shape is not what we expect.
          var added = (addResponse.items && addResponse.items[0]) || addResponse;
          if (!window.wrShowCartConfirm || !window.wrShowCartConfirm(added, cart.item_count)) {
            openCartDrawer();
          }
          if (window.wrAnnounce) {
            window.wrAnnounce('Added to cart. ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ' in your cart.');
          }
        });
      })
      .catch(function (err) {
        if (err && err.message === 'challenge') {
          if (addLabel) addLabel.textContent = 'Verifying connection...';
          window.location.reload();
          return;
        }
        if (err && err.message === 'rate-limited') {
          flash(addLabel, 'Too fast — try again', 'Add to Cart');
          return;
        }
        // Fall back to a normal form post rather than losing the add.
        form.submit();
      })
      .finally(function () { busy = false; });
  }

  form.addEventListener('submit', function (e) {
    var submitter = e.submitter;

    // Buy Now: let the browser post natively and land on checkout.
    if (submitter && submitter.hasAttribute('data-wr-buy')) {
      if (returnTo) returnTo.value = '/checkout';
      if (buyLabel) buyLabel.textContent = 'Redirecting...';
      return;
    }

    // Add to Cart: stay on the page.
    e.preventDefault();
    addToCart();
  });

  // The sticky bar drives the same form rather than duplicating it.
  var stickyBuy = document.querySelector('[data-wr-sticky-buy]');
  var stickyAdd = document.querySelector('[data-wr-sticky-add]');
  if (stickyBuy) stickyBuy.addEventListener('click', function () { if (buyBtn) buyBtn.click(); });
  if (stickyAdd) stickyAdd.addEventListener('click', function () { addToCart(); });

  // A back-forward-cache restore leaves "Redirecting..." frozen on screen.
  window.addEventListener('pageshow', function () {
    if (buyLabel && buyLabel.textContent === 'Redirecting...') {
      buyLabel.textContent = buyBtn && buyBtn.disabled ? 'Sold Out' : 'Buy Now — Checkout';
    }
  });

  /* ── Sticky bar visibility ───────────────────────────── */
  (function stickyBar() {
    var bar = document.querySelector('[data-wr-sticky]');
    var anchor = document.querySelector('[data-wr-buy-stack]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    // Shows once the inline buttons have scrolled past, same trigger as the
    // Framer version — but via IntersectionObserver rather than a scroll
    // listener reading offsetTop on every frame.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    observer.observe(anchor);
  })();
})();
